// File: App.js
import React from 'react';
import Navbar from './Navigationbar';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { motion } from 'framer-motion';
import { Tabs, Tab, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navigationbar from './Navigationbar';
import Login from './Login';


const slides = [
  {
    image: 'https://cdn.pixabay.com/photo/2024/03/19/15/37/call-center-8643477_1280.jpg',
    title: 'AUDIO CALL',
    description: 'AUDIO CALL'
  },
  {
    image: 'https://plus.unsplash.com/premium_photo-1661658092898-a2b9b81d3a30?q=80&w=1632&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    title: 'VIDEO CALL',
    description: 'VIDEO CALL'
  },
  {
    image: 'https://images.unsplash.com/photo-1704964969056-0c6d7caf7af8?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    title: 'CHAT SCREEN',
    description: 'CHAT SCREEN'
  }
];

function Zoom() {
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      />
    );
  }

  var settings = {
    dots: false,
    fade: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
  }
  return (
    <>
      <Navigationbar />
      <div className="slider-container bannerSection">
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <div key={index} className="bannerSectionWrap">
              <img
                src={slide.image}
                alt={slide.title}
                className="bannerImage"
              />
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="bannerContentWrap"
              >
                <motion.p
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                  className="bannerContentText"
                >
                  "{slide.description}"
                </motion.p>
              </motion.div>
            </div>
          ))}
        </Slider>
      </div>
      {/* <Login /> */}
    </>
  );
}

export default Zoom;
